import SlotsHistoryApi from './SlotsHistoryApi';
export default SlotsHistoryApi;
